// extracted by mini-css-extract-plugin
export var colorSquare = "_rp-0";
export var danger = "_rp-5";
export var lightPink = "_rp-8";
export var neutralBlue = "_rp-7";
export var neutralYellow = "_rp-6";
export var normal = "_rp-1";
export var primary = "_rp-2";
export var primaryLight = "_rp-3";
export var solidBlack = "_rp-g";
export var solidGreen = "_rp-b";
export var solidLightBlue = "_rp-d";
export var solidNavy = "_rp-c";
export var solidOrange = "_rp-f";
export var solidPink = "_rp-e";
export var solidRed = "_rp-9";
export var solidYellow = "_rp-a";
export var success = "_rp-4";